import { getRequest, postRequest, putRequest} from "../utils/axiosHandler";
import { toast } from "react-toastify";
import { googleLogout } from "@react-oauth/google";
import axios from "axios";
import { BASE_URL } from "../utils/constants";
export const loginUser = async (email, password) => {
    try {
      const response = await postRequest("/auth/customer/login", { email, password }, true);
      toast.success("Login successful.");
     // console.log("Login Response:", response);
      return response; // Returns success response (token, user data, etc.)
    } catch (error) {
      throw error; // Throw error so the UI can handle it
    }
  };

  export const logoutUser = async () => {
    
    try {
      await postRequest("/auth/customer/logout", {}, true);
      googleLogout();
    } catch (error) {
      throw error;
    }
  };
  
  // Function to check login status
  export const checkLoginStatus = async () => {
    try {
      const response = await getRequest("/auth/customer/check-login", {}, true);
      //console.log("Check Login Response:", response);
      return response; // User data (if logged in)
    } catch (error) {
      // console.error("Check Login Error:", error);
      return null; // Return null if not logged in
    }
  };


export const googleRegister = async (code) => {
  try {
    const response = await postRequest("/auth/customer/google", { code }, true);
    toast.success("Google registration successful.");
    return response; // Returns success response (token, user data, etc.)
  } catch (error) {
    throw error; // Throw error so the UI can handle it
  }
}

export const facebookRegister = async (code) => {
  try {
    const response = await postRequest("/auth/customer/facebook", { code }, true);
    toast.success("Facebook registration successful.");
    return response; // Returns success response (token, user data, etc.)
  } catch (error) {
    throw error; // Throw error so the UI can handle it
  }
}

//direct axios request for logging out for 401
export const logoutUserDirect = async () => {
  const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";
    
  try {
    await axios.post(`${BASE_URL}/auth/customer/logout`, {}, { withCredentials: true });
    //googleLogout();
  } catch (error) {
    // console.log("Logout error:", error);
  }
};

export const registerUser = async (userRequestDTO) => {
  try {
    const response = await postRequest("/auth/customer/register", userRequestDTO, true);
    toast.success("Registration successful.");
    return response; // Returns success response (token, user data, etc.)
  } catch (error) {
   // console.log("Registration error:", error.response?.data);
    const errorMessage = error.response?.data || 'Registration failed. Please try again.';
    toast.error(errorMessage);
    throw error; // Throw error so the UI can handle it
  }
};


export const sendAuthUserOTP = async () => {
  try {
    return await postRequest('/api/v1/customer/otp-notification', {}, true);
  } catch (error) {
    throw error;
  }
}


export const authVerifyOtp = async (otp) => {
  try {
    return await postRequest('/api/v1/customer/verify-otp', {otp}, true);
  } catch (error) {
    throw error;
  }
}


export const authChangePassword = async (token, newPassword) => {
  try {
    return await putRequest('/api/v1/customer/change-password', { token, newPassword }, true);
  } catch (error) {
    throw error;
  }
}



export const onKokoPayButtonClicked = async () => {
  if (!window.kokoPayData) {
    console.error("KOKO Pay data is missing.");
    return;
  }

  try {
    const responseData = await postRequest("/api/vm/user/kokoPay", window.kokoPayData);

   // console.log("KOKO Pay response:", responseData);

    if (responseData) {
      //console.log("KOKO Pay payment process initiated successfully.");

      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://prodapi.paykoko.com/api/merchants/orderCreate";

      Object.entries(responseData).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      //console.log("Form submitted, user redirected to PayKoko for payment.");
    }
  } catch (error) {
    console.error("Error during KOKO Pay request:", error);
  }
};


